module.exports = __webpack_public_path__ + "static/media/heavy_pound03.b46105fb.jpg";